import React from "react";
import styles from "./style.module.scss";
import { Tooltip } from "react-tooltip";
import { brandColours } from "../../assets/brandColours";
import Version from "./version";

interface UnauthenticatedLayoutProps {
  children: React.ReactNode;
  title: string;
  configOptions?: React.ReactNode;
  barColour?: string;
  showVersion?: boolean;
}

function UnauthenticatedLayout(props: UnauthenticatedLayoutProps) {
  const {
    children,
    title,
    configOptions = <></>,
    barColour = brandColours.gold,
    showVersion = false,
  } = props;

  return (
    <>
      <Tooltip id="backendVersionTooltip" />
      <div className={styles.container}>
        <div className={styles.header} style={{ backgroundColor: barColour }}>
          <div className={styles.title}>{title}</div>
          {configOptions}
          {showVersion && <Version />}
        </div>
        <div className={styles.children}>{children}</div>
      </div>
    </>
  );
}

export default UnauthenticatedLayout;
